const rootArea = "/products";

export const productGlob = (baseArea: string) => ({
	self: `${baseArea}${rootArea}`,
	byCode: (configCode: string) => ({ 					
		read: `${baseArea}${rootArea}/${configCode}/read`
	})
});